import { API } from "aws-amplify";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";

export const GET_ATTRIBUTES_DOWNLOAD_TEMPLATE_REQUEST =
  "@@attributes/GET_ATTRIBUTES_DOWNLOAD_TEMPLATE_REQUEST";
export const GET_ATTRIBUTES_DOWNLOAD_TEMPLATE_SUCCESS =
  "@@attributes/GET_ATTRIBUTES_DOWNLOAD_TEMPLATE_SUCCESS";
export const GET_ATTRIBUTES_DOWNLOAD_TEMPLATE_FAILURE =
  "@@attributes/GET_ATTRIBUTES_DOWNLOAD_TEMPLATE_FAILURE";

export function getAttributesDownloadTemplate(
  id = "",
  organisation,
  sample_table = true
) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_ATTRIBUTES_DOWNLOAD_TEMPLATE_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_assets&organisation=${organisation}&sample_table=${sample_table}`;
      }

      const response = await API.get("usimAPI", url);
      dispatch({
        type: GET_ATTRIBUTES_DOWNLOAD_TEMPLATE_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_ATTRIBUTES_DOWNLOAD_TEMPLATE_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_ATTRIBUTES_LIST_REQUEST =
  "@@attributes/GET_ATTRIBUTES_LIST_REQUEST";
export const GET_ATTRIBUTES_LIST_SUCCESS =
  "@@attributes/GET_ATTRIBUTES_LIST_SUCCESS";
export const GET_ATTRIBUTES_LIST_FAILURE =
  "@@attributes/GET_ATTRIBUTES_LIST_FAILURE";

export function getAttributesList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_ATTRIBUTES_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_assets&organisation=${organisation}&sample_table=false`;
      }

      const response = await API.get("usimAPI", url);
      dispatch({
        type: GET_ATTRIBUTES_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_ATTRIBUTES_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const DELETE_ATTRIBUTES_LIST_REQUEST =
  "@@attributes/DELETE_ATTRIBUTES_LIST_REQUEST";
export const DELETE_ATTRIBUTES_LIST_SUCCESS =
  "@@attributes/DELETE_ATTRIBUTES_LIST_SUCCESS";
export const DELETE_ATTRIBUTES_LIST_FAILURE =
  "@@attributes/DELETE_ATTRIBUTES_LIST_FAILURE";

export function deleteAttributesList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: DELETE_ATTRIBUTES_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_assets&organisation=${organisation}`;
      }

      const response = await API.del("usimAPI", url);
      dispatch({
        type: DELETE_ATTRIBUTES_LIST_SUCCESS,
        payload: response,
      });
      dispatch(getAttributesList(id, organisation));
    } catch (error) {
      dispatch({
        type: DELETE_ATTRIBUTES_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const UPLOAD_ATTRIBUTES_DATA_REQUEST =
  "@@attributes/UPLOAD_ATTRIBUTES_DATA_REQUEST";
export const UPLOAD_ATTRIBUTES_DATA_SUCCESS =
  "@@attributes/UPLOAD_ATTRIBUTES_DATA_SUCCESS";
export const UPLOAD_ATTRIBUTES_DATA_FAILURE =
  "@@attributes/UPLOAD_ATTRIBUTES_DATA_FAILURE";

export function uploadAttributesData(
  id = "",
  organisation,
  file,
  columnMappings,
  callback
) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: UPLOAD_ATTRIBUTES_DATA_REQUEST,
    });
    try {
      let url = "/presignedurl";
      if (id) {
        url = `${url}?project_id=${id}&table_name=in_assets`;
      }
      if (!isEmpty(columnMappings)) {
        url = `${url}&column_mappings=${encodeURI(
          JSON.stringify(columnMappings)
        )}`;
      }

      const response = await API.get("usimAPI", url);

      const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": file.type },
        body: file,
      };
      await fetch(response.uploadURL, requestOptions).then((response) => {
        if (response.status === 200) {
          toast.success("Data uploaded successfully!");
          setTimeout(() => {
            dispatch(getAttributesList(id, organisation));
          }, 2000);
          callback({
            success: true,
          });
        } else {
          dispatch({
            type: UPLOAD_ATTRIBUTES_DATA_FAILURE,
            payload: {
              message: "Upload data failed.",
            },
          });
        }
      });

      dispatch({
        type: UPLOAD_ATTRIBUTES_DATA_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: UPLOAD_ATTRIBUTES_DATA_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}
